"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var sel = document.getElementsByClassName("tpa_content");

function initCountDown(datetime) {
  datetime = new Date(datetime + ' UTC').toLocaleString();
  var date = new Date(),
      end_date = new Date(datetime);
  var countdown = (end_date - date) / 1000;
  var clock,
      daily = 'DailyCounter';
  if (countdown < 86400) daily = 'HourlyCounter';
  clock = new FlipClock($('.tpa_content .clock'), {
    clockFace: daily,
    autoStart: false,
    callbacks: {
      stop: function stop() {
        $('.tpa_content .clock').hide();
      }
    }
  });
  clock.setTime(countdown);
  clock.setCountdown(true);
  clock.start();
}

function initSingleCountDown(datetime, sel) {
  var isCollectionPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if ($(sel).width() >= 160 && $(sel).width() < 320) $(sel).closest('[class*="tpa"]').addClass('tpa-x160');
  var date = new Date(),
      end_date = new Date(toLocalTime(datetime).replace(/-/g, "/"));
  var countdown = (end_date - date) / 1000;
  var clock,
      daily = 'DailyCounter';
  var option = {
    clockFace: daily,
    autoStart: false,
    callbacks: {
      stop: function stop() {
        $(sel).closest('[class*="tpa"]').hide();
      }
    }
  };
  if (countdown < 86400) daily = 'HourlyCounter';

  try {
    clock = $(sel).FlipClock(countdown, option);
  } catch (err) {
    clock = new FlipClock($(sel), countdown, option);
  }

  clock.setCountdown(true);
  clock.start(); // Fix for > 100 days

  var listFlips = $(sel).find('.flip');
  var counter = 0;

  for (var i = listFlips.length - 1; i >= 0; i--) {
    if (counter < 6) {
      if (counter % 2 == 0) listFlips.eq(i).addClass('even');else listFlips.eq(i).addClass('odd');
    }

    if (counter < 2) listFlips.eq(i).addClass('seconds');else if (counter < 4) listFlips.eq(i).addClass('minutes');else if (counter < 6) listFlips.eq(i).addClass('hours');else {
      listFlips.eq(i).addClass('days');
      if (counter == 6) listFlips.eq(i).addClass('last');else if (counter == listFlips.length - 1) listFlips.eq(i).addClass('first');else listFlips.eq(i).addClass('between');
    }
    counter++;
  }
}

var engine = new Liquid();

function initEngine() {
  // Register Filter
  engine.registerFilter('format_money', function (v, format) {
    return TPAConfigs.formatMoney(v, format);
  });
  engine.registerFilter('to_string', function (v) {
    return JSON.stringify(v);
  });
  engine.registerFilter('to_json', function (v) {
    return JSON.parse(v);
  });
  engine.registerFilter('isset', function (v) {
    return typeof v !== 'undefined' ? true : false;
  });
  engine.registerFilter('is_later', function (v) {
    return moment(v) > moment() ? true : false;
  });
  engine.registerFilter('replace_id', function (v, id) {
    return v.replace('{id}', id);
  });
  engine.registerFilter('include', function (arr, field) {
    return arr.includes(field);
  });
}

function TPAmain() {
  return _TPAmain.apply(this, arguments);
}

function _TPAmain() {
  _TPAmain = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var installed, auction_container, product_id, activeAuction, statusAuction, hideAtc, hidePrice, form, socket, room, accountSelector;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            // Check install
            installed = false;
            $("script").each(function () {
              if ($(this).text().indexOf("tipo.auction.init.js?") != -1 && $(this).text().indexOf("asyncLoad") != -1 && $(this).text().indexOf("initSchema") == -1) {
                installed = true;
              }

              if (typeof TPAInstalled !== 'undefined') {
                installed = true;
              }
            });

            if (installed) {
              _context4.next = 4;
              break;
            }

            return _context4.abrupt("return", false);

          case 4:
            // If not install, end here
            initEngine();
            auction_container = $('.tpa_content');
            product_id = TPAConfigs.product && TPAConfigs.product.id || null;
            TPAConfigs.state['product_id'] = product_id;
            _context4.next = 10;
            return fetchBidHistory();

          case 10:
            activeAuction = _context4.sent;
            // Hide add to cart , price
            statusAuction = getAuctionStatus(TPAConfigs.product);

            if (TPAConfigs.selector) {
              hideAtc = false, hidePrice = false;

              if (statusAuction === 0) {
                // Stop
                if (TPAConfigs.settings.hide_atc_when_stopped === '1') {
                  hideAtc = true;
                }

                if (TPAConfigs.settings.hide_price_when_stopped === '1') {
                  hidePrice = true;
                }
              }

              if (statusAuction === 1) {
                // Running
                if (TPAConfigs.settings.hide_atc_when_running === '1') {
                  hideAtc = true;
                }

                if (TPAConfigs.settings.hide_price_when_running === '1') {
                  hidePrice = true;
                }
              }

              if (statusAuction === 2) {
                // Pending
                if (TPAConfigs.settings.hide_atc_when_pending === '1') {
                  hideAtc = true;
                }

                if (TPAConfigs.settings.hide_price_when_pending === '1') {
                  hidePrice = true;
                }
              }

              if (hideAtc) {
                $(TPAConfigs.selector.add_to_cart).hide();
              }

              if (hidePrice) {
                $(TPAConfigs.selector.price).eq(0).hide();
                auction_container.find(TPAConfigs.selector.price).attr('style', '');
              }
            } //


            form = $('form[method="post"][action*="/cart/add"]:visible:first');

            if (activeAuction && form.length) {
              // Settings
              if (TPAConfigs.settings.bid_history_column) {
                if (!TPAConfigs.settings.bid_history_column.includes("email")) {
                  auction_container.find('.email_column').hide();
                }

                if (!TPAConfigs.settings.bid_history_column.includes("username")) {
                  auction_container.find('.username_column').hide();
                }

                if (!TPAConfigs.settings.bid_history_column.includes("bid_amount")) {
                  auction_container.find('.bid_amount_column').hide();
                }

                if (!TPAConfigs.settings.bid_history_column.includes("bid_time")) {
                  auction_container.find('.bid_time_column').hide();
                }
              }

              $('.tpa_content').insertAfter(form);
              $('.tpa_content').show();
              $(".tpa_content").attr('data-auction-id', activeAuction.id);
              $(".tpa_content").attr('data-product-id', activeAuction.product_id);
              initSingleCountDown(activeAuction.end_time, $('.tpa_content .clock'), false); // Trans

              auction_container.find('.end_in').text(TPAConfigs.settings.trans_end_in);
              auction_container.find('.bids .label').text(TPAConfigs.settings.trans_bids);
              auction_container.find('.start_price .label').text(TPAConfigs.settings.trans_start_price);
              auction_container.find('.reserve_price .label').text(TPAConfigs.settings.trans_reserve_price);
              auction_container.find('.current_price .label').text(TPAConfigs.settings.trans_current_price);
              auction_container.find('.bidder .label').text(TPAConfigs.settings.trans_bidder);
              auction_container.find('.start_time .label').text(TPAConfigs.settings.trans_start_time);
              auction_container.find('.end_time .label').text(TPAConfigs.settings.trans_end_time);
              auction_container.find('#bid').text(TPAConfigs.settings.trans_bid_now);
              auction_container.find('.automatic_bid_label').text(TPAConfigs.settings.trans_automatic_bid);
              auction_container.find('.automatic_bid_wrapper [tooltip]').attr('tooltip', TPAConfigs.settings.trans_automatic_bid_tooltip);
              auction_container.find('.bid_history_label').text(TPAConfigs.settings.trans_bid_history);
              auction_container.find('.username_label').text(TPAConfigs.settings.trans_username);
              auction_container.find('.email_label').text(TPAConfigs.settings.trans_email);
              auction_container.find('.bid_amount_label').text(TPAConfigs.settings.trans_bid_amount);
              auction_container.find('.bid_time_label').text(TPAConfigs.settings.trans_bid_time);
              auction_container.find('.flip-clock-divider.days .flip-clock-label').text(TPAConfigs.settings.trans_clock_days);
              auction_container.find('.flip-clock-divider.hours .flip-clock-label').text(TPAConfigs.settings.trans_clock_hours);
              auction_container.find('.flip-clock-divider.minutes .flip-clock-label').text(TPAConfigs.settings.trans_clock_minutes);
              auction_container.find('.flip-clock-divider.seconds .flip-clock-label').text(TPAConfigs.settings.trans_clock_seconds);
              auction_container.find('.your_bid .prefix').text(TPAConfigs.money_character);
              $("#stopAuctionModal .modal__header .modal__title").html(TPAConfigs.settings.trans_stop_auction_heading);
              $("#stopAuctionModal .modal__footer .modal__btn-secondary").html(TPAConfigs.settings.trans_stop_auction_close_button);
              $("#stopAuctionModal .modal__footer .modal__btn-primary").html(TPAConfigs.settings.trans_stop_auction_checkout_button); //
              // Bind val

              auction_container.find('.start_price .value').text(TPAConfigs.settings.trans_bids);
              TPAConfigs.formatMoney(TPAConfigs.state.start_price, TPAConfigs.moneyFormat);
              if (activeAuction.settings.automatic_bid) $('.tpa_content .automatic_bid_wrapper').show();else $('.tpa_content .automatic_bid_wrapper').hide();
              TPAConfigs.state['start_price'] = typeof activeAuction.settings.start_price !== 'undefined' ? activeAuction.settings.start_price : TPAConfigs.settings.def_start_price != '' ? TPAConfigs.settings.def_start_price : typeof TPAConfigs.product.price !== 'undefined' ? TPAConfigs.product.price : 1; //         TPAConfigs.state['next_bid'] = TPAConfigs.state['start_price'];

              renderChange();
              $('#bid_price').on('change', function () {
                if (isValidPrice($(this).val() * 100, getValidPrice(true))) {
                  TPAConfigs.state['next_bid'] = $(this).val() * 100;
                } else {
                  TPAConfigs.state['next_bid'] = getValidPrice(true);
                }

                renderChange();
              });
              $(document).on('click', "#bid", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var trans_login_to_bid, anchor, code, regex_replace, m_replace, regex_type, m_type, regex_trans, m_trans;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (TPAConfigs.customer.email != '') {} else {
                          trans_login_to_bid = TPAConfigs.settings.trans_login_to_bid, anchor = '', code = '';
                          regex_replace = /{.*}/;
                          m_replace = regex_replace.exec(TPAConfigs.settings.trans_login_to_bid);

                          if (m_replace && m_replace.length) {
                            code = m_replace[0];
                            regex_type = /[^\{]+(?=\|)/g;
                            m_type = regex_type.exec(TPAConfigs.settings.trans_login_to_bid);
                            regex_trans = /[^\|]+(?=\})/g;
                            m_trans = regex_trans.exec(TPAConfigs.settings.trans_login_to_bid);

                            if (m_type[0] == 'login' && m_trans[0] != '') {
                              anchor = '<a href="#" class="login" onclick="gotoLogin(event)">' + m_trans[0] + '</a>';

                              gotoLogin = function gotoLogin(event) {
                                event.preventDefault();
                                window.location.href = "/account/login?checkout_url=" + window.location.href;
                              };
                            }
                          }

                          trans_login_to_bid = trans_login_to_bid.replace(code, anchor);
                          showMessage(trans_login_to_bid, 'warning');
                        }

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));
              $('.tpa_content .bid-ctrl.minus').click(function () {
                minus();
              });
              $('.tpa_content .bid-ctrl.plus').click(function () {
                plus();
              });

              if (TPAConfigs.customer.email != '') {
                $('#bid').click(function () {
                  var price = parseFloat($(".tpa_content #bid_price").val()) * 100;
                  var auction_id = $(".tpa_content").attr('data-auction-id');
                  var auto_bid = $('#automatic_bid').is(':checked');
                  var variant_id = $('select[name="id"]').val();
                  var bid_data = {
                    url: TPAConfigs.shop_url,
                    auction_id: auction_id,
                    customer_id: TPAConfigs.customer.id,
                    username: TPAConfigs.customer.name,
                    email: TPAConfigs.customer.email,
                    product_id: TPAConfigs.state.product_id,
                    product_title: TPAConfigs.product.title,
                    product_handle: TPAConfigs.product.handle,
                    product_price: TPAConfigs.product.price,
                    product_image: TPAConfigs.product.featured_image,
                    price: price,
                    auto_bid: auto_bid,
                    variant_id: variant_id
                  };
                  socket.emit('bid', bid_data);
                });
              }
            }

            socket = io.connect(TPAConfigs.app_host);
            room = {
              role: "customer",
              url: TPAConfigs.shop_url,
              p_id: TPAConfigs.state.product_id,
              email: TPAConfigs.customer.email
            };
            socket.on('connect', function () {
              socket.emit('room', room);
            });
            socket.on('new bid ' + room.url + ' ' + room.p_id, function (data) {
              var bids = data.data.detail;
              bindDataToTable(bids);
              initSingleCountDown(data.data.auction.end_time, $('.tpa_content .clock'), false);
              TPAConfigs.state['bids'] = bids;
              autoPlus();
            });
            socket.on('success bid', function (message) {
              showMessage(message, 'success');
            });
            socket.on('fail bid', function (message) {
              showMessage(message, 'warning');
            });
            socket.on('stop auction ' + room.url + ' ' + room.p_id, function (res) {
              $('[data-product-id="' + res.p_id + '"]').hide();

              if (res.winner == TPAConfigs.customer.id) {
                if (typeof TPAConfigs.settings.trans_stop_auction_winner_message === 'undefined') {
                  TPAConfigs.settings.trans_stop_auction_winner_message = 'Congratulation! Your are winner. {checkout|Checkout} now';
                }

                $("#stopAuctionModal .modal__footer .modal__btn-primary").attr('data-id', res.auction_detail_id);
                $("#stopAuctionModal .modal__footer .modal__btn-primary").show();
                $("#stopAuctionModal .modal__content").html(replaceLinkCode(TPAConfigs.settings.trans_stop_auction_winner_message, 'checkout', {
                  link: '#',
                  id: res.auction_detail_id
                }));
              } else {
                $("#stopAuctionModal .modal__footer .modal__btn-primary").hide();
                $("#stopAuctionModal .modal__content").html(TPAConfigs.settings.trans_stop_auction_loser_message);
              }

              MicroModal.show('stopAuctionModal');
            }); //   Account Auction Page

            accountSelector = $('body :contains("{tpa-account}")');

            if (accountSelector.length) {
              accountSelector = accountSelector.eq(accountSelector.length - 1);
              fetchAccountPage(accountSelector, 1); // Event go to page

              $(document).on('click', '.tpa-account .tpa-paginate .page.auctions', function () {
                fetchAccountPage(accountSelector, $(this).text());
              });
              $(document).off('click').on('click', '.tpa-account .view', /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          e.preventDefault();
                          e.stopPropagation();
                          $("#tpa_modal").toggleClass("-open");
                          $("#tpa_modal .modal_inner").empty().append('<div class="lds-ring"><div></div><div></div><div></div><div></div></div>');
                          fetchHistoryAuctionDetail($(this).data('id'), 1);
                          $(document).on('click', '.tpa-account .tpa-paginate .page.detail', function () {
                            fetchHistoryAuctionDetail($(this).data('id'), $(this).data('page'));
                          });
                          return _context2.abrupt("return", false);

                        case 7:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, this);
                }));

                return function (_x6) {
                  return _ref2.apply(this, arguments);
                };
              }());
            }

            $(document).on('click', '#tpa_modal,.tpa-account .modal_inner .close', function (e) {
              if (e.target === this) {
                $(this).toggleClass("-open");
              } else if (e.target.className.indexOf('close') > -1) {
                $(this).closest('.modal').toggleClass("-open");
              }
            });
            console.log('hihi');
            $(document).on('click', '.auction-checkout-button', /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
                var id, checkout;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        e.preventDefault();
                        id = $(this).data('id');
                        _context3.next = 4;
                        return $.ajax({
                          url: "https://" + window.location.host + "/apps/auction/front/account/checkout",
                          method: 'GET',
                          data: {
                            email: TPAConfigs.customer.email,
                            shop: TPAConfigs.shop_url,
                            id: id
                          }
                        });

                      case 4:
                        checkout = _context3.sent;
                        window.location.href = checkout;

                      case 6:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, this);
              }));

              return function (_x7) {
                return _ref3.apply(this, arguments);
              };
            }()); // Auction Collection

            if (typeof TPACollection !== 'undefined' && TPAConfigs.settings.show_countdown != '0') {
              $('.tpa-collection').each(function (i, obj) {
                var p_id = $(obj).data('id');

                if (p_id && typeof TPACollection[p_id].metafields !== 'undefined') {
                  var metafields = TPACollection[p_id].metafields;
                  var start_time = metafields.start_time;
                  var end_time = metafields.end_time;
                  var status = getAuctionStatus(TPACollection[p_id]);
                  var _hideAtc = false,
                      _hidePrice = false; // Running auctions

                  if (status === 1) {
                    $(obj).find('.time .label').text(TPAConfigs.settings.trans_end_in);
                    $(obj).find('.end_in').append(end_time);
                    initSingleCountDown(end_time, $(obj).find('.end_in'), true);

                    if (TPAConfigs.settings.hide_atc_when_running === '1') {
                      _hideAtc = true;
                    }

                    if (TPAConfigs.settings.hide_price_when_running === '1') {
                      _hidePrice = true;
                    }
                  } // Pending Auction


                  if (status === 2) {
                    $(obj).find('.time .label').text(TPAConfigs.settings.trans_start_in);
                    $(obj).find('.start_in').append(start_time);
                    initSingleCountDown(start_time, $(obj).find('.start_in'), true);

                    if (TPAConfigs.settings.hide_atc_when_pending === '1') {
                      _hideAtc = true;
                    }

                    if (TPAConfigs.settings.hide_price_when_pending === '1') {
                      _hidePrice = true;
                    }
                  } // Stop Auction


                  if (status === 0) {
                    if (TPAConfigs.settings.hide_atc_when_stopped === '1') {
                      _hideAtc = true;
                    }

                    if (TPAConfigs.settings.hide_price_when_stopped === '1') {
                      _hidePrice = true;
                    }
                  }

                  if (_hideAtc) {
                    $(obj).parent().find(TPAConfigs.selector.add_to_cart).hide();
                  }

                  if (_hidePrice) {
                    $(obj).parent().find(TPAConfigs.selector.price).hide();
                  }

                  $(obj).find('.flip-clock-divider.days .flip-clock-label').text(TPAConfigs.settings.trans_clock_days);
                  $(obj).find('.flip-clock-divider.hours .flip-clock-label').text(TPAConfigs.settings.trans_clock_hours);
                  $(obj).find('.flip-clock-divider.minutes .flip-clock-label').text(TPAConfigs.settings.trans_clock_minutes);
                  $(obj).find('.flip-clock-divider.seconds .flip-clock-label').text(TPAConfigs.settings.trans_clock_seconds);
                }
              });
            }

          case 28:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _TPAmain.apply(this, arguments);
}

function fetchAccountPage(_x, _x2) {
  return _fetchAccountPage.apply(this, arguments);
}

function _fetchAccountPage() {
  _fetchAccountPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(selector, page) {
    var accountData;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(TPAConfigs.customer.email != '')) {
              _context5.next = 6;
              break;
            }

            _context5.next = 3;
            return $.ajax({
              url: "https://" + window.location.host + "/apps/auction/front/account",
              method: 'GET',
              data: {
                email: TPAConfigs.customer.email,
                shop: TPAConfigs.shop_url,
                page: page
              }
            });

          case 3:
            accountData = _context5.sent;
            accountData = JSON.parse(accountData);
            engine.parseAndRender($('#tpa-account').html(), {
              settings: JSON.parse(accountData.shop.settings),
              history: accountData.history
            }).then(function (html) {
              selector.empty().append(html);

              if ($('.tpa-account').width() == $('body').width()) {
                $('.tpa-account').addClass('is-full-width');
              }
            });

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _fetchAccountPage.apply(this, arguments);
}

function fetchHistoryAuctionDetail(_x3, _x4) {
  return _fetchHistoryAuctionDetail.apply(this, arguments);
}

function _fetchHistoryAuctionDetail() {
  _fetchHistoryAuctionDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id, page) {
    var data;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(TPAConfigs.customer.email != '')) {
              _context6.next = 6;
              break;
            }

            _context6.next = 3;
            return $.ajax({
              url: "https://" + window.location.host + "/apps/auction/front/account",
              method: 'GET',
              data: {
                email: TPAConfigs.customer.email,
                shop: TPAConfigs.shop_url,
                page: page,
                id: id
              }
            });

          case 3:
            data = _context6.sent;
            data = JSON.parse(data);
            engine.parseAndRender($('#tpa-history-auction-detail').html(), {
              auction_id: id,
              settings: JSON.parse(data.shop.settings),
              history: data.history,
              TPAConfigs: TPAConfigs
            }).then(function (html) {
              $('.tpa-account #tpa_modal .modal_inner').empty().append('<span class="close">x</span>' + html);
            });

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _fetchHistoryAuctionDetail.apply(this, arguments);
}

function getValidPrice(add, current_price) {
  var settings = TPAConfigs.state.product.settings;
  var bid_step = typeof settings.bid_step !== 'undefined' ? settings.bid_step : TPAConfigs.settings.def_bid_step != '' ? TPAConfigs.settings.def_bid_step : 1;
  var new_price = typeof current_price !== 'undefined' ? current_price : typeof TPAConfigs.state.current_price !== 'undefined' ? TPAConfigs.state.current_price : TPAConfigs.state.start_price;

  if (typeof TPAConfigs.state.current_price === 'undefined') {
    TPAConfigs.state['current_price'] = TPAConfigs.state.start_price;
    return TPAConfigs.state.start_price;
  }

  var isInGap = false;
  var loop = true;

  if (settings && typeof settings.increment_gap !== 'undefined') {
    settings.increment_gap.forEach(function (rule) {
      if (loop && new_price >= rule.from && new_price < rule.to) {
        isInGap = true;

        if (add) {
          new_price += parseInt(rule.amount);
        } else {
          var preAmount = getPreAmount(settings.increment_gap, rule.amount);

          if (new_price - parseInt(rule.amount) >= rule.from && new_price - parseInt(preAmount) >= rule.from) {
            new_price -= parseInt(rule.amount);
          } else {
            new_price -= parseInt(preAmount);
          }
        }

        loop = false;
      }
    });
  }

  if (!isInGap) {
    if (add) new_price += parseInt(bid_step);else new_price -= parseInt(bid_step);
  }

  return new_price < 0 ? 0 : new_price;
}

function isValidPrice(new_price, valid_price) {
  return parseInt(new_price) >= parseInt(valid_price) ? true : false;
}

function getPreAmount(increment_gap, amount) {
  var preAmount = 0;
  var loop = true;
  increment_gap.forEach(function (rule) {
    if (loop) {
      if (amount == rule.amount) {
        loop = false;
      } else {
        preAmount = rule.amount;
      }
    }
  });
  return preAmount;
}

function minus() {
  var curr = parseFloat($('.tpa_content #bid_price').val()) * 100;
  $('.tpa_content #bid_price').val(getValidPrice(false, curr) / 100);
}

function plus() {
  var curr = parseFloat($('.tpa_content #bid_price').val()) * 100;
  $('.tpa_content #bid_price').val(getValidPrice(true, curr) / 100);
}

function autoPlus() {
  if (typeof TPAConfigs.state.bids !== 'undefined') {
    TPAConfigs.state.current_price = typeof TPAConfigs.state.bids.lastest_bid !== 'undefined' ? TPAConfigs.state.bids.lastest_bid.bid_amount : 0;
    TPAConfigs.state.next_bid = getValidPrice(true);
  }

  renderChange();
}

function renderChange() {
  if (TPAConfigs.state) {
    if (typeof TPAConfigs.state.current_price === 'undefined') $('.current_price').hide();else $('.current_price').css('display', 'flex');
    var num_bids = typeof TPAConfigs.state.bids !== 'undefined' ? TPAConfigs.state.bids.count : 0;
    var current_price = typeof TPAConfigs.state.bids.lastest_bid !== 'undefined' ? TPAConfigs.state.bids.lastest_bid.bid_amount : TPAConfigs.state.start_price;
    var bidder = typeof TPAConfigs.state.bids.lastest_bid !== 'undefined' ? TPAConfigs.state.bids.lastest_bid.username : '';
    var start_price = TPAConfigs.state.start_price;
    var reserve_price = TPAConfigs.state.product.settings.reserve_price_enable == "enable" ? TPAConfigs.state.product.settings.reserve_price : 0;
    var start_time = toLocalTime(TPAConfigs.state.product.start_time);
    var end_time = toLocalTime(TPAConfigs.state.product.end_time);

    if (num_bids > 0) {
      $('.bids').css('display', 'flex').find('.value').html(num_bids);
    }

    if (current_price) {
      $('.current_price').css('display', 'flex').find('.money').html(TPAConfigs.formatMoney(current_price, TPAConfigs.moneyFormat));
    }

    if (bidder) {
      $('.bidder').css('display', 'flex').find('.value').html(bidder);
    }

    $('.start_price').css('display', 'flex').find('.money').html(TPAConfigs.formatMoney(TPAConfigs.state.start_price, TPAConfigs.moneyFormat));

    if (TPAConfigs.state.product.settings.reserve_price_enable == "enable" && TPAConfigs.state.product.settings.reserve_price_display) {
      $('.reserve_price').css('display', 'flex').find('.money').html(TPAConfigs.formatMoney(reserve_price, TPAConfigs.moneyFormat));
    } else {
      $('.reserve_price').hide();
    }

    $('.start_time').css('display', 'flex').find('.value').html(start_time);
    $('.end_time').css('display', 'flex').find('.value').html(end_time);

    if (typeof TPAConfigs.state.next_bid !== 'undefined') {
      $('.tpa_content #bid_price').val(TPAConfigs.state.next_bid / 100);
    }

    if (typeof TPAConfigs.state.auto_bid_amount !== 'undefined' && TPAConfigs.state.auto_bid_amount > 0) {
      $('.tpa_content #automatic_bid').prop('checked', true);
      $('.tpa_content #bid_price').val(TPAConfigs.state.auto_bid_amount / 100);
    }
  }
}

function getAuctionStatus(product) {
  if (typeof product === 'undefined' || typeof product.metafields === 'undefined') {
    return -1; // No auction data before
  }

  var startTime = toLocalTime(product.metafields.start_time);
  var endTime = toLocalTime(product.metafields.end_time);
  var now = toLocalTime(new Date());

  if (now < startTime) {
    return 2; // Pending
  }

  if (endTime < now) {
    return 0; // Stop
  }

  return 1; // Running
}

function fetchBidHistory() {
  return _fetchBidHistory.apply(this, arguments);
}

function _fetchBidHistory() {
  _fetchBidHistory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
    var page,
        valid,
        a,
        _args8 = arguments;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            page = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : 1;
            valid = false;

            if (!(typeof TPAConfigs.product === 'undefined' || TPAConfigs.product.tags.length < 2 || TPAConfigs.product.tags.indexOf('auction') == -1 || TPAConfigs.product.tags.indexOf('running') == -1)) {
              _context8.next = 4;
              break;
            }

            return _context8.abrupt("return", false);

          case 4:
            if (TPAConfigs.state.product_id) {
              _context8.next = 6;
              break;
            }

            return _context8.abrupt("return", false);

          case 6:
            _context8.next = 8;
            return fetch(TPAConfigs.app_host + "/api/front/" + TPAConfigs.shop_url + "/" + TPAConfigs.state.product_id + "/auction_detail/" + page).then(function (res) {
              return res.json();
            }).then( /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(res) {
                var html;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        if (!(res.active_auction.id > 0)) {
                          _context7.next = 20;
                          break;
                        }

                        TPAConfigs.state.product = res.active_auction;
                        res.active_auction.settings = JSON.parse(res.active_auction.settings);
                        TPAConfigs.state.start_price = res.active_auction.settings.start_price;
                        valid = res.active_auction;
                        TPAConfigs.state['bids'] = [];

                        if (!(res.detail && res.detail.data.length)) {
                          _context7.next = 18;
                          break;
                        }

                        bindDataToTable(res.detail);

                        if (!TPAConfigs.customer.email) {
                          _context7.next = 11;
                          break;
                        }

                        _context7.next = 11;
                        return fetchAutoBidAmount('https://' + window.location.host + "/apps/auction/api/front/" + TPAConfigs.shop_url + "/" + res.active_auction.id + "/customer/" + TPAConfigs.customer.email);

                      case 11:
                        html = '';
                        TPAConfigs.state['current_price'] = typeof res.detail.lastest_bid.bid_amount !== 'undefined' ? res.detail.lastest_bid.bid_amount : TPAConfigs.state.start_price;
                        TPAConfigs.state['next_bid'] = getValidPrice(true);
                        TPAConfigs.state['bids'] = res.detail;
                        renderChange();
                        _context7.next = 20;
                        break;

                      case 18:
                        TPAConfigs.state['next_bid'] = getValidPrice(true);
                        $(".bid_list tbody").empty().append("<tr><td colspan=" + TPAConfigs.settings.bid_history_column.length + ">" + TPAConfigs.settings.trans_there_is_no_bid + "</td></tr>");

                      case 20:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }));

              return function (_x8) {
                return _ref4.apply(this, arguments);
              };
            }()).catch(function () {});

          case 8:
            a = _context8.sent;
            return _context8.abrupt("return", valid);

          case 10:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _fetchBidHistory.apply(this, arguments);
}

function renderBidRows(username, email, bid_amount, bid_time) {
  var html = '<tr>';

  if (TPAConfigs.settings.bid_history_column.indexOf("username") != -1) {
    html += '<td data-label="Username" class="username_column">' + username + '</td>';
  }

  if (TPAConfigs.settings.bid_history_column.indexOf("email") != -1) {
    html += '<td data-label="Email" class="email_column">' + email + '</td>';
  }

  if (TPAConfigs.settings.bid_history_column.indexOf("bid_amount") != -1) {
    html += '<td data-label="Bid amount" class="bid_amount_column">' + TPAConfigs.formatMoney(bid_amount, TPAConfigs.moneyFormat) + '</td>';
  }

  if (TPAConfigs.settings.bid_history_column.indexOf("bid_time") != -1) {
    html += '<td data-label="Bid time" class="bid_time_column">' + toLocalTime(bid_time) + '</td>';
  }

  return html;
}

function bindDataToTable(bids) {
  var html = '';
  Object.keys(bids.data).forEach(function (key) {
    if (TPAConfigs.state['current_price'] < bids.data[key].bid_amount) {
      TPAConfigs.state['current_price'] = bids.data[key].bid_amount;
    }

    html += renderBidRows(bids.data[key].username, bids.data[key].email, bids.data[key].bid_amount, bids.data[key].bid_time);
  });
  $(".bid_list tbody").empty().append(html);
  paginateTable(bids);
}

function fetchAutoBidAmount(_x5) {
  return _fetchAutoBidAmount.apply(this, arguments);
}

function _fetchAutoBidAmount() {
  _fetchAutoBidAmount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(url) {
    var data;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return $.ajax(url);

          case 2:
            data = _context9.sent;
            TPAConfigs.state['auto_bid_amount'] = data;

          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _fetchAutoBidAmount.apply(this, arguments);
}

function showMessage(message, status) {
  $('.tpa_content .action .message').empty();
  $('.tpa_content .action .message').addClass(status);
  $('.tpa_content .action .message').append('<div class="content">' + message + '</div><div class="dismiss"><svg viewBox="0 0 20 20" class="" focusable="false" aria-hidden="true"><path d="M11.414 10l4.293-4.293a.999.999 0 1 0-1.414-1.414L10 8.586 5.707 4.293a.999.999 0 1 0-1.414 1.414L8.586 10l-4.293 4.293a.999.999 0 1 0 1.414 1.414L10 11.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z" fill-rule="evenodd"></path></svg></div>');
  $('.tpa_content .action .message').css('display', 'flex');
  $('.tpa_content .action .message svg').on('click', function () {
    $('.tpa_content .action .message').fadeOut('slow');
  }); //setTimeout(function(){
  //	$('.tpa_content .action .message').fadeOut('slow')
  //}, 2000);
}

function replaceLinkCode(initialStr, code, data) {
  var anchor = '';
  var regex_replace = /{.*}/;
  var m_replace = regex_replace.exec(initialStr);

  if (m_replace && m_replace.length) {
    code = m_replace[0];
    var regex_type = /[^\{]+(?=\|)/g;
    var m_type = regex_type.exec(initialStr);
    var regex_trans = /[^\|]+(?=\})/g;
    var m_trans = regex_trans.exec(initialStr);

    if (m_type[0] == 'login' && m_trans[0] != '') {
      anchor = '<a href="#" class="login" onclick="gotoLogin(event)">' + m_trans[0] + '</a>';

      gotoLogin = function gotoLogin(event) {
        event.preventDefault();
        window.location.href = "/account/login?checkout_url=" + window.location.href;
      };
    }

    if (m_type[0] == 'checkout' && m_trans[0] != '') {
      anchor = '<a href="' + data.link + '" target="_blank" class="auction-checkout-button" data-id="' + data.id + '">' + m_trans[0] + '</a>';
    }
  }

  return initialStr.replace(code, anchor);
}

TPAConfigs.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || TPAConfigs.moneyFormat;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2, ',', '.');
      break;

    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;

    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, '\'', '.');
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;

    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ', '.');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function paginateTable(bids) {
  if (bids.numPage > 1) {
    Pagination.Init($('.tpa_content .pager')[0], {
      size: bids.numPage,
      page: bids.curPage,
      step: 1
    });
    $('.tpa_content .pager .page-number').on('click', function () {
      if ($(this).hasClass('active') || $(this).hasClass('disable')) return;
      page = $(this).data('page');
      fetchBidHistory(page);
    });
  }
}

function toLocalTime(datetime) {
  return moment(moment.utc(datetime).toDate()).local().format('YYYY-MM-DD HH:mm');
}

if (typeof jQuery == 'undefined') {
  var headTag = document.getElementsByTagName("head")[0];
  var jqTag = document.createElement('script');
  jqTag.type = 'text/javascript';
  jqTag.src = 'https://code.jquery.com/jquery-1.11.1.js';
  jqTag.onload = TPAmain;
  headTag.appendChild(jqTag);
} else {
  TPAmain();
}